import { showError } from "@infrastructure/api/utils/toastNotifications";

export function surfaceDeptActionError(
  message: string,
  setDeptActionError: (msg: string | null) => void
): void {
  setDeptActionError(message);
  showError(message, { autoClose: false });
}
